import BaseOverlay from "./base.jsx";
import { CircularProgress, FlatButton } from "material-ui";
import CheckCircleIcon from "material-ui/svg-icons/action/check-circle";

const styles = {
  icon: {
    width: 80,
    height: "auto",
    color: "rgb(2, 136, 209)"
  }
};

export default ({ onRequestClose, message, complete }) => {
  return (
    <BaseOverlay
      onRequestClose={onRequestClose}
      actions={
        complete
          ? [
              <FlatButton
                primary={true}
                label="Close"
                onTouchTap={onRequestClose}
              />
            ]
          : []
      }
    >
      <div style={{ textAlign: "center" }}>
        {complete ? (
          <CheckCircleIcon style={styles.icon} />
        ) : (
          <CircularProgress
            style={{
              marginBottom: 50
            }}
            mode="indeterminate"
          />
        )}

        <div>{message}</div>
      </div>
    </BaseOverlay>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/loading.jsx